import {
  HHStack,
  HHTextField,
  HHTypography,
} from '@hinge-health/react-component-library';
import Clear from '@mui/icons-material/Clear';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import { Controller } from 'react-hook-form';
import { DateRangeFilterProps } from './filter-types';

export const DateRangeFilter = ({
  control,
  errors,
  name,
  labelFrom,
  labelTo,
  tooltipText,
}: DateRangeFilterProps): JSX.Element => (
  <Controller
    control={control}
    name={name}
    render={({ field: { onChange, value } }): JSX.Element => (
      <Tooltip title={tooltipText} arrow placement="top">
        <HHStack style={{ position: 'relative' }}>
          {(value[0] || value[1]) && (
            <IconButton
              size="small"
              aria-label="Clear"
              onClick={(): void => onChange([null, null])}
              sx={{
                position: 'absolute',
                right: -8,
                top: -8,
                zIndex: 1,
                backgroundColor: 'background.paper',
              }}
            >
              <Clear fontSize="small" />
            </IconButton>
          )}
          <DateRangePicker
            value={value as [Date | null, Date | null]}
            onChange={(newValue): void => onChange(newValue)}
            renderInput={(startProps, endProps): JSX.Element => {
              const { label: _, ...restStart } = startProps;
              const { label: __, ...restEnd } = endProps;
              return (
                <HHStack
                  direction="row"
                  spacing={2}
                  alignItems="flex-end"
                  minWidth={150}
                  maxWidth={230}
                >
                  <HHTextField
                    hhVariant="variant-bypass"
                    variant="standard"
                    type="string"
                    label={labelFrom}
                    InputLabelProps={{ sx: { color: 'gray' } }}
                    error={Object.keys(errors?.[name] ?? {}).length !== 0}
                    helperText={errors[name]?.message as string}
                    {...restStart}
                  />
                  <HHTypography hhVariant="body1"> to </HHTypography>
                  <HHTextField
                    hhVariant="variant-bypass"
                    variant="standard"
                    type="string"
                    label={labelTo}
                    InputLabelProps={{ sx: { color: 'gray' } }}
                    error={Object.keys(errors?.[name] ?? {}).length !== 0}
                    helperText={errors[name]?.message as string}
                    {...restEnd}
                  />
                </HHStack>
              );
            }}
          />
        </HHStack>
      </Tooltip>
    )}
  />
);
